<div class="button-container">
    <div>
        <button (click)="export_fun()" class="ms-5">Export Training Reports</button>
    </div>
</div>